import { ArrowLeft } from 'lucide-react';
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { setNewPassword } from '../../services/users';
import { notify } from '../../helpers';
import { useDocumentTitle } from '../../hooks/customDocumentTitleHook';
import Spacing from '../Spacing';

export default function ChangePassword() {
  const [passwords, setPasswords] = useState({
    password: '',
    confirm_password: '',
  });

  const navigate = useNavigate();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  const now = new Date();
  const currentYear = now.getFullYear();

  const handleChange = (e) => {
    setPasswords({
      ...passwords,
      [e.target.name]: e.target.value,
    });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if(!passwords.password || !passwords.confirm_password) {
        notify('error', 'Please fill out all fields');
      return;
    }
    if (passwords.password !== passwords.confirm_password) {
      notify('error', 'Passwords do not match');
      return;
    }

    try {
      const data = await setNewPassword(passwords, token);
      if (data?.data?.message) {
        notify("success", "Password changed successfully");
        navigate("/login", { replace: true });
      }
    } catch (error) {
      notify('error', 'Failed to change password');
    }
  };

  useDocumentTitle("Change Password");

  return (
    <div className="docpro_login_wrap">
      <div
        className="docpro_login_thumb"
        style={{ backgroundImage: 'url(/images/login_img.png)' }}
      ></div>
      <div className="docpro_login_right">
        <div className="docpro_login_card_wrap">
          <form className="docpro_login_card" onSubmit={handlePasswordSubmit}>
            <div className="docpro_text_center">
              <img src="/images/logo_2.svg" alt="Logo" />
              <Spacing lg="32" sm="32" />
              <h1 className="docpro_mb_0">Change Your Password</h1>
            </div>
            <Spacing lg="20" sm="20" />
            <label className="docpro_fw_500 docpro_primary_color docpro_fs_16">
              New Password <span className="red-color">*</span>
            </label>
            <input
              type="password"
              className="docpro_form_field size_lg"
              name="password"
              onChange={handleChange}
            />
            <Spacing lg="20" sm="20" />
            <label className="docpro_fw_500 docpro_primary_color docpro_fs_16">
              Confirm Password <span className="red-color">*</span>
            </label>
            <input
              type="password"
              className="docpro_form_field size_lg"
              name="confirm_password"
              onChange={handleChange}
            />
            <Spacing lg="20" sm="20" />
            <button
              type="submit"
              className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn docpro_fs_16" onSubmit={handlePasswordSubmit}
            >
              <span>Change Password</span>
            </button>
            <Spacing lg="20" sm="20" />
            <div className="docpro_text_center docpro_fs_16 docpro_fw_500">
              <Link to="/login" className="docpro_back_btn_2">
                <ArrowLeft /> Back to Sign in
              </Link>
            </div>
          </form>
        </div>
        <footer className="docpro_login_footer">
          <div className="docpro_login_footer_nav">
            <Link to="/">Privacy policy</Link>
            <Link to="/">Terms & conditions</Link>
            <Link to="/">Terms of service</Link>
            <Link to="/">HIPAA Compliance</Link>
          </div>
          <p>© {currentYear} DocPro. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
